var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountTie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account-tie-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.222,
    height: 16,
    viewBox: "0 0 14.222 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "account-tie-outline-2",
    "data-name": "account-tie-outline",
    d: "M14.987,11.676c1.733.587,3.236,1.547,3.236,2.88V19H4V14.556c0-1.333,1.5-2.293,3.244-2.88l.551,1.1.2.444c-1.333.409-2.311,1-2.311,1.333v2.756H9.44l.782-4.507-.836-1.671a15.352,15.352,0,0,1,1.724-.107,15.351,15.351,0,0,1,1.724.107L12,12.8l.782,4.507h3.751V14.556c0-.338-.978-.924-2.311-1.333l.2-.444.56-1.1m-3.876-6.9a1.778,1.778,0,1,0,1.778,1.778,1.783,1.783,0,0,0-1.778-1.778m0,5.333a3.556,3.556,0,1,1,3.556-3.556A3.555,3.555,0,0,1,11.111,10.111Z",
    transform: "translate(-4 -3)",
    fill: "#445c37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountTie);
export default __webpack_public_path__ + "static/media/accountTie.b43a959cbc849623f3151f19e010e6cf.svg";
export { ForwardRef as ReactComponent };